// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"69667d97","239":"64059782","453":"05ac9d23","732":"393edf7d"}[chunkId] + ".chunk.js";
};